import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import cx from 'clsx';
import { Illustration } from './illustration/illustration';
import styles from './q-state.module.css';

// Title component with semantic HTML and typography
interface TitleProps extends ComponentPropsWithoutRef<'h2'> {
  as?: ElementType;
}

function QState({
  children,
  className = '',
  ...props
}: ComponentPropsWithoutRef<'div'>): ReactNode {
  return (
    <div className={cx(styles.wrapper, className)} {...props}>
      {children}
    </div>
  );
}

function ActionsContainer({ children, ...props }: ComponentPropsWithoutRef<'div'>): ReactNode {
  return (
    <div className={styles.actions} {...props}>
      {children}
    </div>
  );
}

function LegendContainer({ children, ...props }: ComponentPropsWithoutRef<'p'>): ReactNode {
  return (
    <p className="body-standard" {...props}>
      {children}
    </p>
  );
}

function TitleContainer({ children, as: Component = 'h2', ...props }: TitleProps): ReactNode {
  return (
    <Component className={cx('heading-section', styles.title)} {...props}>
      {children}
    </Component>
  );
}

const QStateComponent = Object.assign(QState, {
  Illustration,
  Title: TitleContainer,
  Legend: LegendContainer,
  Actions: ActionsContainer,
});

export { QStateComponent as QState };
